import { render, staticRenderFns } from "./nuevoUsuario.vue?vue&type=template&id=b7714cac&scoped=true"
import script from "./nuevoUsuario.vue?vue&type=script&lang=js"
export * from "./nuevoUsuario.vue?vue&type=script&lang=js"
import style0 from "./nuevoUsuario.vue?vue&type=style&index=0&id=b7714cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7714cac",
  null
  
)

export default component.exports